import { render } from "./BudgetProgram.vue?vue&type=template&id=42230b0b"
import script from "./BudgetProgram.vue?vue&type=script&lang=js"
export * from "./BudgetProgram.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1559117955/src/employer_portal_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__